import { render, staticRenderFns } from "./AllForms.vue?vue&type=template&id=0afcab5a&"
import script from "./AllForms.vue?vue&type=script&lang=ts&"
export * from "./AllForms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports